import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const ExtensionSelectorParts = [
  'container',
  'header',
  'headerText',
  'extensionBadge',
  'extensionBadgeText',
] as const

const helpers = createMultiStyleConfigHelpers(ExtensionSelectorParts)
export const ExtensionSelector = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '100%',
      padding: '0rem 1.25rem',
      gap: '.5rem',
    },
    header: {
      display: 'flex',
      padding: '0.5rem 0.75rem 0rem 0.75rem',
      alignItems: 'center',
      gap: '0.5rem',
      alignSelf: 'stretch',
    },
    headerText: {
      color: 'gray.1300',
      fontSize: '0.875rem',
      fontWeight: '700',
    },
    extensionBadge: {
      display: 'flex',
      height: '1.5rem',
      padding: '0rem 0.5rem',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
      borderRadius: '3.125rem',
      textAlign: 'center',
    },
    extensionBadgeText: {
      fontSize: '0.875rem',
      fontWeight: '600',
    },
  },
})

export const useExtensionSelectorStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof ExtensionSelectorParts>(
    getName({ ExtensionSelector }),
    props,
  )
}
